"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var axios_1 = require("axios");
var DealerblockBestOfferService = (function () {
    function DealerblockBestOfferService() {
    }
    DealerblockBestOfferService.prototype.acceptDeclientImolaServiceCall = function (bestOfferId, orgId, conversationId, ssoToken, url) {
        var imolaUrl = url + "?boid=" + bestOfferId + "&orgId=" + orgId + "&conversationId=" + conversationId;
        return axios_1.default.get(imolaUrl, {
            headers: {
                'Content-Type': 'text/javascript',
                'x-openlane-authentication': ssoToken,
                'Access-Control-Max-Age': 300
            }
        });
    };
    DealerblockBestOfferService.prototype.acceptDeclineIfBidImolaServiceCall = function (orgId, conversationId, auctionId, ssoToken, url) {
        var imolaUrl = url + "?aid=" + auctionId + "&orgId=" + orgId + "&conversationId=" + conversationId;
        return axios_1.default.get(imolaUrl, {
            headers: {
                'Content-Type': 'text/javascript',
                'x-openlane-authentication': ssoToken,
                'x-openlane-api': true,
                'Access-Control-Max-Age': 300
            }
        });
    };
    return DealerblockBestOfferService;
}());
DealerblockBestOfferService.decorators = [
    { type: core_1.Injectable },
];
/** @nocollapse */
DealerblockBestOfferService.ctorParameters = function () { return []; };
exports.DealerblockBestOfferService = DealerblockBestOfferService;
//# sourceMappingURL=dealerblock-best-offer.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nw/dealerblock-bid-ui/shared/services/dealerblock-best-offer.service.js
// module id = 9YXM
// module chunks = 0